export default __webpack_public_path__ + "static/media/bicycle.9574eaaa.svg";